/**
 * web-payments.js — monetizzazione web dell'app Capacitor (Stripe).
 *
 * Caricato SOLO dalla shell PHP (window.TY_WEB = true), DOPO tutti gli script
 * nativi e js/web.js. Sul nativo questo file non viene mai incluso: lì i
 * pagamenti restano IAP (store). Qui le funzioni native di pagamento vengono
 * sovrascritte PER ASSEGNAZIONE (mai function declaration: verrebbero
 * hoistate sopra le native) con le versioni web portate dalla webapp legacy
 * (frontend/webapp/src): checkout Stripe Hosted, gift card, billing portal,
 * storico pagamenti.
 *
 * Espone come router: tyWebPaymentsRoute(path, qs) — chiamato da js/web.js.
 */

/* ------------------------------------------------------------------ *
 * Originali nativi (catturati PRIMA degli override qui sotto)
 * ------------------------------------------------------------------ */

// Acquisto in-app di app.js: dentro l'app Capacitor la shell web e' la stessa,
// ma i pagamenti devono restare sullo store — js/native-payments.js rimette
// questa implementazione al posto del checkout Stripe.
var tyNativeStartPayInApp = (typeof startPayInApp === 'function') ? startPayInApp : null;

/* ------------------------------------------------------------------ *
 * Helpers
 * ------------------------------------------------------------------ */

function tyWebIsLogged() {
    return typeof userData !== 'undefined' && !!userData && userData.status == 'success';
}

// valore da URLSearchParams | oggetto piano | fallback sull'URL corrente
function tyWebQsGet(qs, name) {
    try {
        if (qs && typeof qs.get === 'function') { return qs.get(name); }
        if (qs && typeof qs === 'object') { return (name in qs) ? qs[name] : null; }
    } catch (e) {}
    return getUrlParameter(name);
}

// i parametri arrivano dall'URL: mai iniettarli in HTML senza escape
function tyWebEscape(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function tyWebSpinnerHtml() {
    return `<div class="col-md-12 text-center row" style="margin-top:10vh;"><svg class="circularLoading" height="50" width="50"><circle class="path" cx="25" cy="25.2" r="19.9" fill="none" stroke-width="6" stroke-miterlimit="10" /></svg></div>`;
}

function tyWebParseJson(json) {
    try {
        return (typeof json === 'string') ? JSON.parse(json) : json;
    } catch (e) {
        return null;
    }
}

// nel capacitor non esiste: portata da frontend/webapp/src/js/settings.js
if (typeof window.getCurrencySymbol !== 'function') {
    window.getCurrencySymbol = function (currencyCode) {
        try {
            return new Intl.NumberFormat('en', {
                style: 'currency',
                currency: currencyCode
            }).formatToParts(1).find(function (part) { return part.type === 'currency'; }).value;
        } catch (error) {
            return '€';
        }
    };
}

/* ------------------------------------------------------------------ *
 * Contenitori pagina (dentro .sectionContainer, gestiti da navigateToPage)
 * ------------------------------------------------------------------ */

function tyWebEnsurePaymentPages() {
    if ($('.pageMob-checkout').length) { return; }
    var $container = $('.sectionContainer');
    if (!$container.length) { return; }
    $container.append(`
        <div class="pageMob pageMob-checkout" style="display:none;"></div>
        <div class="pageMob pageMob-giftcard" style="display:none;"></div>
        <div class="pageMob pageMob-giftcard_redeem" style="display:none;"></div>
        <div class="pageMob pageMob-thankyou" style="display:none;"></div>
        <div class="pageMob pageMob-payments" style="display:none;"></div>
    `);
}

$(function () {
    tyWebEnsurePaymentPages();
});

/* ------------------------------------------------------------------ *
 * Override: preview pagamenti / pricing (da webapp all_scr.js)
 * ------------------------------------------------------------------ */

// apre la pagina checkout (ex /paymentPreview della webapp) e ci renderizza
// le card dei piani. Sostituisce la modal IAP nativa.
openModalPaymentPreview = function (idc = null) {
    var full_url_api = URL_API + '/collection/?f=get_payment_preview';
    if (idc) {
        full_url_api += '&id=' + encodeURIComponent(idc);
    }

    tyWebEnsurePaymentPages();
    navigateToPage('checkout');
    // entry con l'id del contenuto: URL SEO /checkout?id=<collection>
    if (idc) { try { Nav.replaceTop('checkout-' + idc); } catch (e) {} }
    $('#mobile-logo-native-label').html(translate('SUBSCRIPTION'));
    $('.pageMob-checkout').html('');
    getListPricing('.pageMob-checkout', full_url_api, { "showImage": false });
};

// versione web: card dei piani (payment_type fixed|subs|rent, ricorrenze,
// giorni di trial, featured). Click sulla card → checkout Stripe.
getListPricing = function (el, url, options) {
    options = options || {};
    $(el).html(tyWebSpinnerHtml());
    $.ajax({
        type: 'GET',
        async: true,
        url: url,
        success: function (json) {
            var objSeriesPremium = tyWebParseJson(json);
            if (!Array.isArray(objSeriesPremium)) { objSeriesPremium = []; }
            tyWebRenderPricing(el, objSeriesPremium, options);
        },
        error: function () {
            $(el).html('');
        }
    });
};

// Render delle card dal payload di get_payment_preview. Estratto da
// getListPricing perche' lo riusa js/native-payments.js: dentro l'app nativa
// la pagina checkout e' la stessa, cambiano solo i piani (solo quelli
// disponibili sullo store) e il prezzo (quello dello store).
function tyWebRenderPricing(el, objSeriesPremium, options) {
    options = options || {};
    if (!Array.isArray(objSeriesPremium)) { objSeriesPremium = []; }

    var htmlTemp = '';
    if (objSeriesPremium.length > 0) {
        htmlTemp += `<h1 class="text-center xbold white mb-3 titlePaymentPreview premiumContentsTitleBoxLabel">${translate("CHOOSE_THE_OFFER_AND_ACCESS")}</h1><div class="flex-row">`;

        for (var z = 0; z < objSeriesPremium.length; z++) {
            var item = objSeriesPremium[z];
            var id = item.id;
            if (item.id_parent) {
                id = item.id_parent;
            }

            var title = getCurrentStringML(item.title, currentLang);
            var description = getCurrentStringML(item.description, currentLang);
            // testo puro della full description (la webapp lo ricavava
            // appendendo un div al body: qui si evita di sporcare il DOM)
            var fullDescriptionText = $('<div>').html(getCurrentStringML(item.full_description, currentLang) || '').text();

            var image = '';
            if (options.showImage == true && item.img_preview) {
                image = `<div class=""><div class="image-wrapper-responsive mb-2"><img loading="lazy" src="${item.img_preview}"/></div></div>`;
            }

            var priceVal = '';
            var periodVal = '';

            if (item.price_final) {
                priceVal = item.price_final;
            }

            if (item.payment_mode == 'monthly') {
                periodVal = `/${translate('MONTHLY')}`;
            }
            if (item.payment_mode == 'quarterly') {
                periodVal = `/${translate('QUARTERLY')}`;
            }
            if (item.payment_mode == 'half_yearly') {
                periodVal = `/${translate('SEMESTRAL')}`;
            }
            if (item.payment_mode == 'yearly') {
                periodVal = `/${translate('YEARLY')}`;
            }
            if (item.payment_type == 'rent') {
                periodVal = ` ${translate('RENT')} ${(item.rent_days || '')} ${translate('DAYS')}`;
            }

            var fullPriceElements = `<h1 class='white bold'><span class='paymentItemCurrencySymbol' style='margin-right:10px;'>${item.currencySymbol || ''}</span>${priceVal} <span class='paymentItemPeriodValue' style='font-size:18px;font-weight:normal;'>${periodVal}</span></h1>`;

            if (!!item.days_trial) {
                fullPriceElements += `<p class='white pHomeStandard'>${item.days_trial} ${translate('TRIAL_DAYS')}</p>`;
            }

            var callToActionTxt = translate('ACTIVE');
            if (item.payment_type == 'fixed') {
                callToActionTxt = translate('BUY');
            }
            if (item.payment_type == 'subs') {
                callToActionTxt = translate('SUBSCRIBE_TO_THIS');
            }
            if (item.payment_type == 'rent') {
                callToActionTxt = translate('RENT');
            }

            // il bottone sta DENTRO la card cliccabile: senza stopPropagation
            // il tap fa partire il checkout due volte (sul nativo lo store
            // apre due schede d'acquisto sovrapposte)
            var onclicklink = `style="cursor:pointer;" onclick="tyWebStartCheckout('${tyWebEscape(id)}');"`;
            var callToActionBtnHtml = `<a onclick="event.stopPropagation(); tyWebStartCheckout('${tyWebEscape(id)}'); return false;" class="mt-2 button-primary callToAction">${callToActionTxt}</a>`;

            var classFeatured = '';
            if (item.featured == true) {
                classFeatured = 'itemPricingFeatured';
            }

            htmlTemp += `<div ${onclicklink} class="flex-col transition-zoom itemPricing"><div class="hero-area-content itemPricingContent white ${classFeatured}">${image}<div class="box-description-pp text-center"><h3 class="white mt-2 title-section-premium-pack xbold">${title}</h3>${fullPriceElements}<p class="pStandardHome white mt-1 description-premium-pack">${description}</p></div><div class="full-description-premium-pack mt-1">${fullDescriptionText}</div><div class="text-center">${callToActionBtnHtml}</div></div></div>`;
        }
        htmlTemp += '</div>';
    } else {
        htmlTemp = `<p class="white text-center" style="margin-top:10vh;">${translate('NO_ACTIVE_PLAN')}</p>`;
    }

    $(el).html(`<div class="premiumContents">${htmlTemp}</div>`);
}

// click su un piano: login se serve, poi checkout con eventuale coupon in URL
function tyWebStartCheckout(productId) {
    if (!productId) { return false; }
    if (!tyWebIsLogged()) {
        openModalLogin(true);
        return false;
    }
    var params = null;
    var code = getUrlParameter('code_discount') || getUrlParameter('code');
    if (code) {
        params = { code_discount: code };
    }
    startPayInApp(productId, 'standard', params);
}

linkPaymentIapPreview = function (id) {
    if (!tyWebIsLogged()) {
        openModalLogin(true);
        return false;
    }
    tyWebStartCheckout(id);
};

/* ------------------------------------------------------------------ *
 * Overlay di attesa del checkout: copre la pagina dalla richiesta della
 * sessione Stripe fino al redirect (che può richiedere qualche secondo)
 * ------------------------------------------------------------------ */

function tyWebCheckoutLoading(show) {
    var $ov = $('#ty-web-checkout-loading');
    if (!show) { $ov.remove(); return; }
    if ($ov.length) { return; }
    $('body').append(`
        <div id="ty-web-checkout-loading" role="status" aria-busy="true">
            <div class="ty-web-checkout-loading-spinner"></div>
        </div>
    `);
}

// tornando indietro da Stripe il browser può ripristinare la pagina dalla
// bfcache con l'overlay ancora sopra
window.addEventListener('pageshow', function (e) {
    if (e.persisted) { tyWebCheckoutLoading(false); }
});

/* ------------------------------------------------------------------ *
 * Override: checkout Stripe (da webapp all_scr.js startPayInApp)
 * ------------------------------------------------------------------ */

startPayInApp = function (productId, type = 'standard', params = null) {
    if (!productId) { return false; }

    var startCheckout = function () {
        if (!tyWebIsLogged()) {
            tyWebCheckoutLoading(false);
            openModalLogin(true);
            return false;
        }
        tyWebCheckoutLoading(true);

        var dataString = 'id=' + encodeURIComponent(productId) + Object.entries(params || {})
            .map(function (entry) { return '&' + entry[0] + '=' + encodeURIComponent(entry[1] == null ? '' : entry[1]); })
            .join('');

        $.ajax({
            type: 'POST',
            url: URL_API1 + '/pay/?f=' + (type == 'gift' ? 'create_payment_giftcard_checkout' : 'create_payment_checkout'),
            data: dataString,
            cache: false,
            dataType: 'json',
            timeout: 30000,
            success: function (json) {
                if (json && json.url) {
                    // l'overlay resta fino al cambio pagina
                    window.location.href = json.url; // Stripe Hosted Checkout
                    return;
                }
                tyWebCheckoutLoading(false);
                open_notifications_toast((json && json.message) || translate('ERROR'), 'red');
            },
            error: function () {
                tyWebCheckoutLoading(false);
                open_notifications_toast(translate('ERROR') + ' 1003', 'red');
            }
        });
    };

    if (!params || !params.code_discount) { return startCheckout(); }

    if (tyWebIsLogged()) { tyWebCheckoutLoading(true); }

    // il "coupon" potrebbe essere una gift card: in quel caso si va al redeem
    $.ajax({
        type: 'POST',
        url: URL_API + '/coupon/?f=check_coupon',
        data: 'code=' + encodeURIComponent(params.code_discount),
        cache: false,
        dataType: 'json',
        timeout: 15000,
        success: function (json) {
            try {
                if (json && json.giftcard) {
                    tyWebCheckoutLoading(false);
                    loadPageUnlockGiftcard(params.code_discount);
                    return;
                }
                startCheckout();
            } catch (error) {
                startCheckout();
            }
        },
        error: function () {
            startCheckout();
        }
    });
};

/* ------------------------------------------------------------------ *
 * Override: impostazioni pagamenti (da webapp settings.js)
 * ------------------------------------------------------------------ */

// web: con abbonamenti Stripe gestibili → Billing Portal, altrimenti pricing
// Voce "Payments" del profilo: da loggati apre la pagina pagamenti web
// (abbonamenti + link al Billing Portal Stripe), da sloggati il pricing.
openIapSettings = function () {
    if (!tyWebIsLogged()) {
        openModalPaymentPreview();
        return;
    }
    tyWebOpenPayments();
};

// Stripe Billing Portal. flow = deep link del portale creato lato API
// (es. 'payment_method_update'): un path accodato all'URL della sessione
// non è supportato da Stripe e apre una pagina sbagliata.
function openBillingPage(flow) {
    tyWebCheckoutLoading(true);
    $.ajax({
        type: 'GET',
        url: URL_API2 + '/payments/users/billing' + (flow ? '?flow=' + encodeURIComponent(flow) : ''),
        cache: false,
        success: function (json) {
            var obj = tyWebParseJson(json);
            if (obj && obj.url) {
                // l'overlay resta fino al cambio pagina
                window.location.href = obj.url;
            } else {
                tyWebCheckoutLoading(false);
                open_notifications_toast(translate('ERROR'), 'red');
            }
        },
        error: function () {
            tyWebCheckoutLoading(false);
            open_notifications_toast(translate('ERROR'), 'red');
        }
    });
}

/* ------------------------------------------------------------------ *
 * Pagina pagamenti nel profilo (abbonamenti + azioni)
 * Lo storico transazioni/fatture NON viene replicato qui: lo mostra già
 * il Billing Portal di Stripe (invoice_history), a cui si rimanda.
 * ------------------------------------------------------------------ */

function tyWebOpenPayments() {
    if (!tyWebIsLogged()) {
        openModalLogin(true);
        return false;
    }
    tyWebEnsurePaymentPages();
    navigateToPage('payments');
    $('#mobile-logo-native-label').html(translate('PAYMENTS'));

    $('.pageMob-payments').html(`
        <div class="ty-web-payments">
            <section class="ty-pay-section">
                <h4 class="ty-pay-heading">${translate('SUBSCRIPTION')}</h4>
                <div class="ty-pay-card list-subscriptions-user">
                    <div class="ty-pay-loading"><svg class="circularLoading" height="50" width="50"><circle class="path" cx="25" cy="25.2" r="19.9" fill="none" stroke-width="6" stroke-miterlimit="10" /></svg></div>
                </div>
            </section>

            <section class="ty-pay-section">
                <div class="ty-pay-card">
                    ${tyWebPaymentActionHtml('ri-bank-card-2-line', translate('EDIT_PAYMENT_METHOD'), "openBillingPage('payment_method_update')")}
                    ${tyWebPaymentActionHtml('ri-file-list-3-line', translate('PAYMENTS'), 'openBillingPage()')}
                    ${tyWebPaymentActionHtml('ri-sparkling-2-line', translate('DISCOVER_PLANS'), 'openModalPaymentPreview()')}
                </div>
            </section>
        </div>
    `);

    tyWebGetSubscriptions();
}

function tyWebPaymentActionHtml(icon, label, onclick) {
    return `
        <a href="#" onclick="${onclick}; return false;" class="ty-pay-row ty-pay-action">
            <span class="ty-pay-action-icon"><i class="${icon}"></i></span>
            <span class="ty-pay-action-text">${label}</span>
            <i class="ty-pay-chevron ri-arrow-right-s-line"></i>
        </a>`;
}

// stato dell'abbonamento → badge (stesse precedenze della webapp)
function tyWebSubscriptionStatus(sub) {
    var status = { key: 'other', label: '', order: 2 };
    if (sub.status_subscription == 'active') {
        status = { key: 'active', label: translate('ACTIVE'), order: 0 };
    }
    if (sub.status_subscription == 'pending' || sub.status_subscription == 'pending-pastdue') {
        status = { key: 'pending', label: translate('PENDING'), order: 1 };
    }
    if (sub.canceled == '1') {
        status = { key: 'cancelling', label: translate('IN_CANCELLATION'), order: 2 };
    }
    if (sub.status_subscription == 'canceled') {
        status = { key: 'canceled', label: translate('CANCELED'), order: 3 };
    }
    return status;
}

// "2026-08-04 15:34:23" → "4 ago 2026" nella lingua dell'utente
function tyWebFormatDate(value) {
    var d = new Date(String(value || '').replace(' ', 'T'));
    if (!value || isNaN(d.getTime())) { return String(value || ''); }
    var lang = (typeof currentLang !== 'undefined' && currentLang) ? currentLang : undefined;
    try {
        return d.toLocaleDateString(lang, { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (e) {
        return d.toLocaleDateString();
    }
}

// cancellati oltre questa soglia finiscono dietro "Mostra altro"
var TY_WEB_CANCELED_VISIBLE = 3;

// abbonamenti dell'utente (da webapp settings.js getSubscriptions):
// attivi in cima, poi i più recenti
function tyWebGetSubscriptions() {
    var $list = $('.list-subscriptions-user');
    $.ajax({
        type: 'POST',
        url: URL_API + '/user/?f=get_user_subscriptions',
        cache: false,
        success: function (json) {
            var objJson = tyWebParseJson(json);
            if (!Array.isArray(objJson)) { objJson = []; }

            var subs = objJson
                .filter(function (sub) { return sub && sub.status == 'success'; })
                .map(function (sub) { return { sub: sub, status: tyWebSubscriptionStatus(sub) }; })
                .sort(function (a, b) {
                    if (a.status.order != b.status.order) { return a.status.order - b.status.order; }
                    return String(b.sub.started_on || '').localeCompare(String(a.sub.started_on || ''));
                });

            if (subs.length == 0) {
                $list.html(`
                    <div class="ty-pay-empty">
                        <span class="ty-pay-empty-icon"><i class="ri-vip-crown-line"></i></span>
                        <p>${translate('NO_ACTIVE_PLAN')}</p>
                        <a href="#" onclick="openModalPaymentPreview(); return false;" class="button-primary">${translate('DISCOVER_PLANS')}</a>
                    </div>`);
                return false;
            }

            var canceledCount = subs.filter(function (s) { return s.status.key == 'canceled'; }).length;
            var collapse = canceledCount > TY_WEB_CANCELED_VISIBLE + 1;
            var canceledSeen = 0;
            var hiddenCount = 0;
            var hasManageable = false;
            var html = '';

            subs.forEach(function (s) {
                var sub = s.sub;
                var hidden = false;
                if (s.status.key == 'canceled') {
                    canceledSeen++;
                    hidden = collapse && canceledSeen > TY_WEB_CANCELED_VISIBLE;
                    if (hidden) { hiddenCount++; }
                } else {
                    hasManageable = true;
                }

                var meta = translate('FROM') + ' ' + tyWebEscape(tyWebFormatDate(sub.started_on));
                if (sub.code) {
                    meta += ' · ' + translate('CODE') + ' ' + tyWebEscape(sub.code);
                }

                html += `
                    <div class="ty-pay-row ty-pay-sub ty-pay-sub--${s.status.key}${hidden ? ' ty-pay-sub--more' : ''}">
                        <div class="ty-pay-sub-main">
                            <div class="ty-pay-sub-title">${tyWebEscape(sub.title)}</div>
                            <div class="ty-pay-sub-meta">${meta}</div>
                        </div>
                        ${s.status.label ? `<span class="ty-pay-badge ty-pay-badge--${s.status.key}">${s.status.label}</span>` : ''}
                    </div>`;
            });

            if (hiddenCount > 0) {
                html += `
                    <a href="#" onclick="$(this).closest('.list-subscriptions-user').addClass('ty-pay-expanded'); return false;" class="ty-pay-row ty-pay-more">
                        ${translate('SHOW_MORE')} (${hiddenCount})
                        <i class="ri-arrow-down-s-line"></i>
                    </a>`;
            }

            // con soli abbonamenti cancellati non c'è un piano da gestire:
            // fatture e metodo di pagamento restano nelle azioni sotto
            if (hasManageable) {
                html += `
                    <a href="#" onclick="openBillingPage(); return false;" class="ty-pay-row ty-pay-manage">
                        <span>${translate('MANAGE_PLAN')}</span>
                        <i class="ri-arrow-right-line"></i>
                    </a>`;
            }

            $list.html(html);
        },
        error: function () {
            $list.html(`<div class="ty-pay-empty"><p>${translate('ERROR')}</p></div>`);
        }
    });
}

/* ------------------------------------------------------------------ *
 * Gift card (porting completo da frontend/webapp/src/js/giftcard.js)
 * ------------------------------------------------------------------ */

function loadPageGiftcard() {
    tyWebEnsurePaymentPages();
    navigateToPage('giftcard');
    $('#mobile-logo-native-label').html('Gift Card');
    $('.pageMob-giftcard').html(renderGiftCard());
    loadAllGiftCard();
    initFormHandling();
}

function createGiftCardForm() {
    var template = `
    <form style="max-width:900px;" class="container mb-2" id="paymentGiftcardForm">

        <h1 class="xbold white">Gift Card</h1>
        <p>Select a gift card</p>
        <select id="giftcardSelectInput" name="id" class="form-control">
        </select>

        <div class="form-group mt-3">
            <input type="text" name="message" placeholder="${translate("CUSTOM_MESSAGE")}" class="form-control">
            <label class="form-label">${translate("CUSTOM_MESSAGE")}</label>
        </div>

        <div class="form-group mt-2">
            <input type="email" id="email" name="email_receiver_gift" placeholder="${translate("RECEIVER_EMAIL_ADDRESS")}" class="form-control">
            <label class="form-label">${translate("RECEIVER_EMAIL_ADDRESS")}</label>
        </div>
        <p class="font-size-12">
            ${translate("IF_NOT_COMPILE_THIS_YOULL_RECEIVE_THE_GIFT")}
        </p>

        <p class="disclaimerGiftCard1 font-size-12 mt-3 col-md-12 padding-0 white">
            ${translate("GIFTCARD_NEED_TO_BE_USED_IN_THE_YEAR")}
        </p>

        <div class="col-md-12 padding-0 text-right">
            <button class="button-primary" id="startPayGiftcard">
                ${translate("BUY")}
            </button>
        </div>
    </form>
    `;
    return template;
}

function renderGiftCard() {
    return createGiftCardForm();
}

function initCustomDropdown() {
    var select = document.getElementById('giftcardSelectInput');
    if (!select) { return { loadOptions: function () {} }; }

    var wrapper = document.createElement('div');
    wrapper.className = 'custom-select-wrapper';

    var customSelect = document.createElement('div');
    customSelect.className = 'custom-select';

    var selectedOption = document.createElement('div');
    selectedOption.className = 'selected-option';

    var optionsList = document.createElement('div');
    optionsList.className = 'options-list';

    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(customSelect);
    customSelect.appendChild(selectedOption);
    customSelect.appendChild(optionsList);
    wrapper.appendChild(select);
    select.style.display = 'none';

    selectedOption.addEventListener('click', function (e) {
        e.stopPropagation();
        customSelect.classList.toggle('open');
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.custom-select-wrapper')) {
            customSelect.classList.remove('open');
        }
    });

    function updateSelectedOption(option) {
        var parts = option.text.split('########');
        selectedOption.innerHTML = `
            <div class="option-item selected">
                <img src="${option.dataset.src || ''}" alt="${parts[0] || ''}">
                <div class="option-info">
                    <span class="title">${parts[0] || ''}</span>
                    <span class="description">${parts[1] || ''}</span>
                </div>
                <span class="price">${parts[2] || ''}</span>
            </div>
        `;
    }

    function loadOptions() {
        optionsList.innerHTML = '';
        Array.from(select.options).forEach(function (option) {
            var parts = option.text.split('########');
            var optionElement = document.createElement('div');
            optionElement.className = 'option-item';
            optionElement.innerHTML = `
                <img src="${option.dataset.src || ''}" alt="${parts[0] || ''}">
                <div class="option-info">
                    <span class="title">${parts[0] || ''}</span>
                    <span class="description">${parts[1] || ''}</span>
                </div>
                <span class="price">${parts[2] || ''}</span>
            `;

            optionElement.addEventListener('click', function (e) {
                e.stopPropagation();
                select.value = option.value;
                updateSelectedOption(option);
                customSelect.classList.remove('open');
                select.dispatchEvent(new Event('change'));
            });

            optionsList.appendChild(optionElement);
        });

        if (select.options.length > 0) {
            updateSelectedOption(select.options[0]);
        }
    }

    return { loadOptions: loadOptions };
}

function loadAllGiftCard() {
    var select = document.getElementById('giftcardSelectInput');
    if (!select) { return; }

    $.ajax({
        url: URL_API + '/collection/?f=get_payment_preview&all_giftcard=true',
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            if (!Array.isArray(data)) { return; }
            select.innerHTML = '';

            data.forEach(function (option) {
                var description = option.description || '';
                var truncatedDescription = description.length > 120
                    ? description.substring(0, 120) + '...'
                    : description;

                var optionHtml = `${option.title || ''}########${truncatedDescription}########${option.price_final || ''}${option.currencySymbol || ''}`;

                var optionElement = document.createElement('option');
                optionElement.value = option.id;
                optionElement.dataset.src = option.img_preview || '';
                optionElement.textContent = optionHtml;
                select.appendChild(optionElement);
            });

            var customDropdown = initCustomDropdown();
            customDropdown.loadOptions();

            var idc = getUrlParameter('idc');
            if (idc && select.querySelector(`option[value="${CSS.escape(idc)}"]`)) {
                select.value = idc;
                select.dispatchEvent(new Event('change'));
            }
        },
        error: function (xhr, status, error) {
            console.error('Error loading gift cards:', error);
        }
    });
}

function initFormHandling() {
    $('#paymentGiftcardForm').on('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(this);
        var params = {};
        formData.forEach(function (value, key) {
            if (key != 'id') {
                params[key] = value;
            }
        });

        var productId = formData.get('id') || '0';

        startPayInApp(productId, 'gift', params);
    });
}

// thank you gift card acquistata: codice + link condivisibile per il riscatto
function loadPageGiftcardThankYou(params) {
    params = params || {};
    var code = params.code != null ? params.code : getUrlParameter('code');
    var date_end = params.date_end != null ? params.date_end : getUrlParameter('date_end');
    var title = params.title != null ? params.title : getUrlParameter('title');
    var image = params.image != null ? params.image : getUrlParameter('image');

    var html = `<div style="text-align: center;" class="ty-web-thankyou">
        <h3 class="white">Gift Card: ${tyWebEscape(title)}</h3>
        <p>${translate("PURCHASED_CORRECTLY")}</p>
        ${image ? `<img src="${tyWebEscape(image)}" width="200px;">` : ''}
        <p class="mt-2">Code</p>
        <h3 class="white" style="border-radius:8px; padding:5px; border: 1px solid #383838;">${tyWebEscape(code)}</h3>
        <p>${translate("VALID_UNTIL")} ${tyWebEscape(date_end)}</p>
        <p style="border-radius:8px; padding:5px; border: 1px solid #383838;">${tyWebEscape(companyDomain)}/giftcard_redeem?code=${tyWebEscape(encodeURIComponent(code || ''))}</p>
        <button onclick="navigateToPage('home');" class="mt-2 button-primary">${translate("CLOSE")}</button>
        </div>
    `;

    tyWebEnsurePaymentPages();
    navigateToPage('thankyou');
    $('.pageMob-thankyou').html(html);
}

// riscatto gift card: login obbligatorio prima di poter attivare il codice
function loadPageUnlockGiftcard(code) {
    code = code != null ? code : (getUrlParameter('code') || '');

    var html = `<div class="text-center fixed_w_s ty-web-giftcard-redeem"><h3 class="white">Gift Card</h3>
        <p>${translate("ACTIVATE_GIFTCARD")}</p>
        <div class="form-group mt-2">
            <input type="text" id="giftcard_unlock_code" value="${tyWebEscape(code)}" name="code" placeholder="Code" class="form-control">
            <label class="form-label">Code</label>
            <button class="button-primary mt-2" onclick="submitGiftCard();">${translate("CONTINUE")}</button>
        </div></div>
    `;

    tyWebEnsurePaymentPages();
    navigateToPage('giftcard_redeem');
    $('#mobile-logo-native-label').html('Gift Card');
    $('.pageMob-giftcard_redeem').html(html);

    // come la webapp (mobile.js): il riscatto richiede un utente loggato
    if (!tyWebIsLogged()) {
        openModalLogin(true);
    }
}

function submitGiftCard() {
    var code = $('#giftcard_unlock_code').val();

    if (!code) {
        open_notifications_toast(translate('ERROR'), '#f71010');
        return;
    }

    if (!tyWebIsLogged()) {
        openModalLogin(true);
        return false;
    }

    $.ajax({
        type: 'POST',
        url: URL_API2 + '/giftcards/redeem',
        data: 'code=' + encodeURIComponent(code),
        cache: false,
        dataType: 'json',
        success: function (json) {
            open_notifications_toast(translate('SUCCESS_ACTIVATION'), '#4BB543');
            renderSubmittedGiftCard(json);
        },
        error: function () {
            open_notifications_toast(translate('ERROR'), '#f71010');
        }
    });
}

function renderSubmittedGiftCard(json) {
    json = json || {};
    try { localStorage.clear(); } catch (e) {}

    var continueAction = (json.type === 'collection' && json.id)
        ? `openSerieThumb('${tyWebEscape(json.id)}');`
        : `navigateToPage('home');`;

    var html = `<div style="text-align: center;" class="ty-web-thankyou">
        <h3 class="white">${translate("SUCCESS_ACTIVATION")}</h3>
        ${json.title ? `<h3 class="white">${json.title}</h3>` : ''}
        ${json.image ? `<img width="200px" src="${json.image}">` : ''}
        ${json.description ? `<p class="mt-2">${json.description}</p>` : ''}
        ${json.date_end ? `<p class="mt-1">${translate("VALID_UNTIL")} ${json.date_end}</p>` : ''}
        <button class="mt-2 button-primary" onclick="${continueAction}">${translate("CONTINUE")}</button>
        </div>
    `;

    $('.pageMob-giftcard_redeem').html(html);
}

/* ------------------------------------------------------------------ *
 * Thank you post-checkout (ritorno da Stripe)
 * ------------------------------------------------------------------ */

function tyWebLoadThankyou(qs) {
    try { localStorage.clear(); } catch (e) {}

    var id = tyWebQsGet(qs, 'id');
    var type = tyWebQsGet(qs, 'type');

    if (type == 'giftcard') {
        loadPageGiftcardThankYou({
            code: tyWebQsGet(qs, 'code'),
            date_end: tyWebQsGet(qs, 'date_end'),
            title: tyWebQsGet(qs, 'title'),
            image: tyWebQsGet(qs, 'image')
        });
        open_notifications_toast(translate('PURCHASED_CORRECTLY'), '#4BB543');
        return;
    }

    var openContentBtn = '';
    if (id && (type == 'collection' || type == 'package')) {
        var openCall = (type == 'package')
            ? `openSerieThumb('${tyWebEscape(id)}', false, true);`
            : `openSerieThumb('${tyWebEscape(id)}');`;
        openContentBtn = `<button class="button-primary mt-2" onclick="${openCall}">${translate('CONTINUE')}</button>`;
    }

    tyWebEnsurePaymentPages();
    navigateToPage('thankyou');
    $('.pageMob-thankyou').html(`
        <div class="text-center ty-web-thankyou">
            <i class="ri-checkbox-circle-line" style="font-size:60px;color:#2eb60d;"></i>
            <h2 class="white xbold">${translate('PURCHASED_CORRECTLY')}</h2>
            ${openContentBtn}
            <div><button class="button-void mt-2" onclick="navigateToPage('home');">${translate('GO_BACK_HOME')}</button></div>
        </div>
    `);
    open_notifications_toast(translate('PURCHASED_CORRECTLY'), '#4BB543');
}

/* ------------------------------------------------------------------ *
 * Router (chiamato da js/web.js con path + querystring della shell)
 * ------------------------------------------------------------------ */

function tyWebPaymentsRoute(path, qs) {
    path = path || window.location.pathname;
    if (qs == null) {
        try { qs = new URLSearchParams(window.location.search); } catch (e) { qs = null; }
    }

    // ordine importante: i path più specifici prima dei loro prefissi
    if (path.indexOf('/checkout-cart') === 0 || path.indexOf('/checkout/cart') === 0) {
        var idc = tyWebQsGet(qs, 'idc');
        var code = tyWebQsGet(qs, 'code_discount') || tyWebQsGet(qs, 'code');
        var cartUrl = window.location.pathname + window.location.search;
        tyWebEnsurePaymentPages();
        navigateToPage('checkout');
        // Nav scrive '/checkout': si rimette l'URL del carrello, che il login
        // usa come reflink per tornare qui con idc e codice sconto
        try { window.history.replaceState(window.history.state, '', cartUrl); } catch (e) {}
        $('.pageMob-checkout').html(tyWebSpinnerHtml());
        if (idc) {
            startPayInApp(idc, 'standard', code ? { code_discount: code } : null);
        }
        return true;
    }

    if (path.indexOf('/checkout') === 0 || path.indexOf('/paymentPreview') === 0) {
        openModalPaymentPreview(tyWebQsGet(qs, 'idc') || tyWebQsGet(qs, 'id'));
        return true;
    }

    if (path.indexOf('/payments') === 0) {
        tyWebOpenPayments();
        return true;
    }

    if (path.indexOf('/giftcard_redeem') === 0) {
        loadPageUnlockGiftcard(tyWebQsGet(qs, 'code'));
        return true;
    }

    if (path.indexOf('/giftcard') === 0 || path.indexOf('/paymentGiftcard') === 0) {
        loadPageGiftcard();
        return true;
    }

    if (path.indexOf('/thankyou') === 0) {
        tyWebLoadThankyou(qs);
        return true;
    }

    return false;
}
